module.exports = __webpack_public_path__ + "static/OpenSans-Regular-3ed9575dcc488c3e3a5bd66620bdf5a4.ttf";